export const SERVICE_TYPE_CHOICES = {
  boarding: 'overnight-boarding',
  traveling: 'overnight-traveling',
  dropIn: 'drop-in',
  dayCare: 'doggy-day-care',
  walking: 'dog-walking',
  onDemandWalking: 'on-demand-dog-walking',
};

export const GUARANTEE_SERVICE_TYPE_CHOICES = [
  SERVICE_TYPE_CHOICES.boarding,
  SERVICE_TYPE_CHOICES.traveling,
  SERVICE_TYPE_CHOICES.dropIn,
  SERVICE_TYPE_CHOICES.dayCare,
  SERVICE_TYPE_CHOICES.walking,
];



// WEBPACK FOOTER //
// ./js/constants/serviceConstants.js